import './index.css'
import * as React from 'react'
import { connect } from 'react-redux'
import DropZoneSvg from 'assets/icons/drop-zone.svg'
import { isDeviceTypePhone } from '@disco/state-management/selectors/app'
import FileSelect from 'components/common/file-select'
import PublicTrackItem from 'components/public/track-item'
import Icon from 'components/ui/icon'
import VerticalSpacer from 'components/ui/vertical-spacer'
import {
  withTranslation,
  type WithTranslation,
} from '@disco/i18n/with-translation'
type Props = {
  businessData: Record<string, any>
  onFileSelect: (...args: Array<any>) => any
  playlist: Record<string, any>
  deleteTrack: (...args: Array<any>) => any
  onUploadCancel: (...args: Array<any>) => any
  app: Record<string, any>
  isPhone: boolean
  preview?: boolean
} & WithTranslation

class Playlist extends React.Component<Props> {
  _fileSelector: Record<string, any> | null | undefined = null

  render() {
    const { tempItems } = this.props.playlist
    const displayPlaylist = tempItems.length > 0
    return (
      <React.Fragment>
        {displayPlaylist && (
          <div className="upload-playlist">
            <div className="upload-playlist__title">
              {this.props.t('inboxes:files', 'Files')}
            </div>
            {this._renderItems()}
          </div>
        )}
        {this._renderDropArea()}
      </React.Fragment>
    )
  }

  _renderItems() {
    const { tempItems } = this.props.playlist
    return tempItems.map((item, index) => {
      const deleteBlock = (
        <Icon
          type="cancel"
          className="upload-playlist__item__info__delete"
          onClick={() => this.props.onUploadCancel(item)}
          width="24px"
          height="24px"
        />
      )
      return (
        <div key={index} className="upload-playlist__item">
          <PublicTrackItem
            location="public-upload-page"
            mediaSource="public-upload-page"
            showWaveform={false}
            track={item}
            actions={
              <div className="upload-playlist__item__info">{deleteBlock}</div>
            }
          />
        </div>
      )
    })
  }

  _renderDropArea() {
    return (
      <div className="playlist__drop-area">
        <div className="playlist__drop-area__header clearfix">
          <span className="playlist__drop-area__header__title">
            {this.props.t('inboxes:fileUpload', 'File upload')}
          </span>
        </div>
        <VerticalSpacer type="small" />
        <FileSelect
          className="playlist__drop-area__container"
          multiple
          onChange={this.props.onFileSelect}
          ref={r => {
            this._fileSelector = r
          }}
          disabled={this.props.preview}
        >
          <DropZoneSvg className="playlist__drop-area__container__icon" />
          <span>
            {this.props.isPhone
              ? this.props.t(
                  'inboxes:tapToBrowseFiles',
                  'Tap here to browse and upload files',
                )
              : this.props.t(
                  'inboxes:dragAndDropOrBrowse',
                  'Drag and drop files anywhere on the page, or click here to browse',
                )}
          </span>
        </FileSelect>
      </div>
    )
  }
}

export default connect(state => {
  return {
    isPhone: isDeviceTypePhone(state),
  }
})(withTranslation('inboxes')(Playlist)) as any
